<template>
    <div>
        <div class="text-base text-blue-1" >
            {{inputLbl.name}}
        </div>
        <div class="relative pb-5">
            <input type="tel"
                class="w-full bg-white px-3 py-2 placeholder-gray-500 text-gray-1 rounded-lg text-22"
                :class="['border', getClass()]"
                v-model="content"
                :placeholder="inputLbl.placeholder"
                :maxlength="inputMaxLength"
                :disabled="disbleForm"
                @input="onChange()">
        </div>
    </div>
</template>
<script>

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "ShowThaiId",
    props: {
        // v-model
        inputValue:     { type: String },
        // props
        // errorInfo:      { type: Object, required: true },
        // isShowError:    { type: Boolean, default: false },
        // isSubmitted:    { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },

        isDisable:      { type: Boolean, default: false },
        checkUpdateProfile: { type: Boolean, default: false },
        displayThaiId: { type: String },
    },
    data: function() {
        return {
            content: this.displayThaiId,
            inputMaxLength: 13,
            inputMinLength: 13,

            disbleForm: this.isDisable,
            displayIdCard: '',
        };
    },
    computed: {

    },
    created: function() {
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function() {
        let thaiId = this.content.substring(0, 9);
        this.content = thaiId + 'xxxx'
        this.disbleForm = true;

    },
    methods: {
        getClass: function () {
            if(this.disbleForm) return 'bg-gray-2'
        },
    },
}
</script>
